<template>
  <div v-bind="data" class="container">
    <div class="content">
      <img src="../assets/ment_report_back.png" class="header-img" />
      <div v-if="current === 1">
        <div class="activty">
          <p class="activty-header">活动一：吹泡泡</p>
          <div class="activty-container">
            <div class="activty-border">
              <p class="activty-border-title">泡泡</p>
            </div>
            <p class="section-title">活动目标</p>
            <p class="t-row">1. 复习如何在吹泡泡游戏中使用同看，同玩，同说</p>
            <p class="t-row">
              2. 练习活动中使用适合孩子发育水平的模仿，提示，重说
            </p>
          </div>
        </div>

        <div class="step">
          <p class="step-title">第一步：我将在活动中运用语言互动的技巧</p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">同看：</span>
              <p class="answer">{{ data.result.a14 }}</p>
            </div>
            <div class="step-row">
              <span class="title">同玩：</span>
              <p class="answer">{{ data.result.a15 }}</p>
            </div>
            <div class="step-row">
              <span class="title">同说：</span>
              <p class="answer">{{ data.result.a16 }}</p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第二步：选择孩子的模仿阶段：<span calss="span">{{
              data.result.a2
            }}</span>
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">我会让孩子模仿:</span>
              <p class="answer">
                {{ data.result.a3 }}
              </p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第二步：如果孩子在模仿时遇到困难， 我将会使用
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">口头提示中的:</span>
              <p class="answer">
                {{ data.result.a4 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a5 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">视觉提示中的:</span>
              <p class="answer">
                {{ data.result.a6 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a7 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">触觉提示中的:</span>
              <p class="answer">
                {{ data.result.a8 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a9 }}
              </p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第三步：
            在整个活动中我将关注孩子想要表达，但是还不会说或说不清楚的字词。
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">我会记住“不纠错”：</span>
              <p class="answer">
                {{ data.result.a10 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">同时会运用 解说：</span>
              <p class="answer">
                {{ data.result.a11 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">强调/夸张：</span>
              <p class="answer">
                {{ data.result.a12 }}
              </p>
            </div>
            <div class="step-row">
              <span class="title">并且频繁地重复：</span>
              <p class="answer">
                {{ data.result.a13 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">来重说孩子想要表达的字词</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="current === 2">
        <div class="activty">
          <p class="activty-header">活动一：{{ data.result.a17 }}</p>
          <div class="activty-container">
            <div class="activty-border">
              <p class="activty-border-title">{{ data.result.a17 }}</p>
            </div>
            <p class="section-title">活动目标</p>
            <p class="t-row">
              1.
              在针对目标音的活动中以同看，同玩，同说为基础，练习使用适合孩子发育水平的模仿，提示，重说
            </p>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第一步：设计适合目标音的活动（情景/玩具）
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">我会：</span>
              <p class="answer">
                {{ data.result.a34 }}
              </p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">第二步：我将在活动中运用语言互动的技巧</p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">同看：</span>
              <p class="answer">{{ data.result.a18 }}</p>
            </div>
            <div class="step-row">
              <span class="title">同玩：</span>
              <p class="answer">{{ data.result.a19 }}</p>
            </div>
            <div class="step-row">
              <span class="title">同说：</span>
              <p class="answer">{{ data.result.a20 }}</p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第三步：选择孩子的模仿阶段：<span calss="span">{{
              data.result.a21
            }}</span>
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">我会让孩子模仿：</span>
              <p class="answer">
                {{ data.result.a22 }}
              </p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第四步：如果孩子在模仿时遇到困难， 我将会使用
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">口头提示中的:</span>
              <p class="answer">
                {{ data.result.a23 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a24 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">视觉提示中的:</span>
              <p class="answer">
                {{ data.result.a25 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a26 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">触觉提示中的:</span>
              <p class="answer">
                {{ data.result.a27 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">技能我会:</span>
              <p class="answer">
                {{ data.result.a28 }}
              </p>
            </div>
          </div>
        </div>

        <div class="step">
          <p class="step-title">
            第五步： 整个活动中我将重点关注孩子的目标音：
          </p>
          <div class="step-border-content">
            <div class="step-row">
              <span class="title">我会记住“不纠错”，</span>
              <p class="answer">
                {{ data.result.a29 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">同时会运用 解说：</span>
              <p class="answer">
                {{ data.result.a30 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">强调/夸张：</span>
              <p class="answer">
                {{ data.result.a31 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title">并且频繁地重复：</span>
              <p class="answer">
                {{ data.result.a32 }}
              </p>
            </div>

            <div class="step-row">
              <span class="title"> 来重说孩子想要表达的字词</span>
            </div>
          </div>
        </div>

        <div class="step-border-content">
          <div class="step-row">
            <p class="answer">
              <span class="row-span">备注:</span>{{ data.result.a33 }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-button">
      <div class="button" @click="onNext">
        {{ current === 1 ? '查看活动二' : '查看活动一' }}
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string';
import BaseURL from '../static/config';
export default {
  name: 'MentPlan',
  components: {},
  data() {
    return {
      data: undefined,
      current: 1,
    };
  },

  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const requestURL = BaseURL
    this.axios
      .get(`${requestURL}ment_children/${searchParams.child_id}`)
      .then((res) => {
        this.data = res.data;
      });
  },
  methods: {
    onNext() {
      if (this.current === 1) {
        this.current = 2;
      } else {
        this.current = 1;
      }

      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.header-img {
  width: 100%;
}
.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  background-color: #e3f4ff;
  box-sizing: border-box;
}

.content {
  flex: 1;
  margin-bottom: 70px;
}

.division {
  width: 100%;
  height: 1px;
  background-color: #49afad;
}

.title {
  color: #49afad;
}

.background {
  background-color: #49afad;
  width: 100%;
  margin-top: 15px;
  border-radius: 4px;
  overflow: hidden;
}

.background > h4 {
  color: white;
}

h4 {
  padding: 5px 10px;
  margin: 0;
  text-align: left;
}

.a1 {
  width: 100%;
  border: 1px #d1d1d1 solid;
  margin: 16px 0;
  border-radius: 6px;
}

h5 {
  padding: 10px 10px;
  margin: 0;
  text-align: left;
}

.list {
  margin: 10px 0;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.row {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #49afad;
  justify-content: flex-start;
  margin-right: 6px;
}

.row > span {
  font-size: 18px;
  font-weight: bold;
  color: #49afad;
}

.list > .t-row {
  color: #49afad;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin: 4px 0 4px 10px;
}

.step {
  margin: 10px 15px;
  padding: 15px;
  background-color: white;
  border-radius: 10px;
}

.step-title {
  text-align: left;
  font-weight: 500;
  color: #153b60;
  font-weight: 16px;
  margin: 0;
  padding: 0;
}

.step-title > .span {
  color: #333 !important;
}

.step .step-border-content {
  width: 100%;
  border: 1px #d1d1d1 solid;
  margin: 16px 0 0 0;
  border-radius: 6px;
}

.step-border-content {
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
}

.step-row {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
  text-align: left;
}

.step-row > .answer > .row-span {
  font-weight: bold;
  font-size: 16px;
  color: #49afad;
}

.step-row > .title {
  font-weight: bold;
  font-size: 16px;
  color: #153b60;
}

.step-row > .answer {
  text-align: left;
  margin: 0;
  padding: 0;
  color: #3a7eee;
  margin-left: 15px;
}

.bottom-button {
  position: fixed;
  display: flex;
  height: 44px;
  width: 100%;
  background-color: white;
  color: white;

  bottom: 0;
  right: 0;
  left: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.button {
  display: flex;
  height: 44px;
  background-color: #3f7eef;
  width: 100%;
  margin: 7px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
}

.activty {
  margin: 0 15px;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  overflow: hidden;
}

.activty-header {
  background-color: #3a7eee;
  margin: 0;
  padding: 0;
  text-align: left;
  padding: 15px;
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.activty-container {
  padding: 15px;
}

.activty-border {
  border: 1px solid #e8e9ea;
  height: 40px;
  padding: 0 10px;
}
.activty-border-title {
  text-align: left;
  line-height: 40px;
  margin: 0;
}

.section-title {
  text-align: left;
  color: #153b60;
  font-size: 16px;
  font-weight: bold;
}

.activty-container > .t-row {
  color: #153b60;
  font-size: 14px;
  text-align: left;
  padding: 0;
  margin: 5px 0 0 0;
}
</style>
